import { blocksGlobalKeypadForModalStack } from '@/constants/modal-stack';
import { create } from 'zustand';

interface ModalStackState {
    modalStack: string[];
    pushModal: (modalId: string) => void;
    popModal: (modalId: string) => void;
    getTopModal: () => string | undefined;
    isTopModal: (modalId: string) => boolean;
    isModalInStack: (modalId: string) => boolean;
    clearStack: () => void;
    blocksGlobalKeypad: () => boolean;
}

export const useModalStackStore = create<ModalStackState>((set, get) => ({
    modalStack: [],

    pushModal: (modalId: string) => {
        set((state) => {
            if (state.isModalInStack(modalId)) {
                return { modalStack: state.modalStack };
            }
            const newStack = [...state.modalStack];
            // Remove modal if it already exists to avoid duplicates
            const filteredStack = newStack.filter((id) => id !== modalId);
            // Add modal to the top
            return { modalStack: [...filteredStack, modalId] };
        });
    },

    popModal: (modalId: string) => {
        set((state) => ({
            modalStack: state.modalStack.filter((id) => id !== modalId),
        }));
    },

    isModalInStack: (modalId: string) => {
        const { modalStack } = get();
        return modalStack.includes(modalId);
    },

    getTopModal: () => {
        const { modalStack } = get();
        return modalStack.length > 0 ? modalStack[modalStack.length - 1] : undefined;
    },

    isTopModal: (modalId: string) => {
        const { modalStack } = get();
        return modalStack.length > 0 && modalStack[modalStack.length - 1] === modalId;
    },

    clearStack: () => {
        set({ modalStack: [] });
    },

    blocksGlobalKeypad: () => {
        return blocksGlobalKeypadForModalStack(get().modalStack);
    },
}));
